import './header.scss';
import clsx from 'clsx';
import { NavLink } from 'react-router';
import { useEffect, useState } from 'react';
import { useTgStore } from '@/stores/tg';

interface HeaderProps {
  withBorder: boolean; // will show border-bottom with shadow
}

function Header({ withBorder = false }: HeaderProps) {
  // const { isAuthenticated, setIsAuthenticated } = useUserStore();
  //
  // const headerLinks = useMemo(() => {
  //   if (isAuthenticated) {
  //     return [{ label: 'Занятия', icon: 'pi-users', url: '/classes' }];
  //   }
  //   return [];
  // }, [isAuthenticated]);
  //
  // const logout = async () => {
  //   try {
  //     // await api.auth.logout();
  //     setIsAuthenticated(false);
  //     window.open('/login');
  //   } catch (e) {
  //     console.error(e);
  //   }
  // };
  const isTgAIPage = location.pathname.startsWith('/ai/answers/');
  const [theme, setTheme] = useState<'light' | 'dark'>('light');
  const { tgTheme } = useTgStore();

  useEffect(() => {
    if (isTgAIPage) {
      setTheme(tgTheme);
    }
  }, [tgTheme]);

  return (
    <nav className={clsx('header', withBorder && 'header_border-bottom', theme)}>
      <div className="header__content">
        <div className="header__left">
          <h3 className={clsx('header__main-logo', theme)}>
            <img className="header__main-logo-img" src="/logo.png" alt="logo" />
            <NavLink to={!isTgAIPage ? '/' : '#'}>Repeteka</NavLink>
          </h3>
          <div className={clsx('header__links', theme)}>
            {/*{headerLinks.map((link) => (*/}
            {/*  <NavLink*/}
            {/*    className="header__link"*/}
            {/*    to={link.url}*/}
            {/*    target="_blank"*/}
            {/*    key={link.url}*/}
            {/*    rel="noreferrer"*/}
            {/*  >*/}
            {/*    <i className={clsx('pi', link.icon, 'header__link-icon')}></i>*/}
            {/*    <span className="header__link-text">{link.label}</span>*/}
            {/*  </NavLink>*/}
            {/*))}*/}
            <NavLink
              className={clsx('header__link', theme)}
              to={'https://t.me/repeteka_bot'}
              target="_blank"
              rel="noreferrer"
            >
              <img src="/meeting_icons/tg_bot.svg" />
              <span className={clsx('header__link-text', theme)}>Repeteka bot</span>
            </NavLink>
          </div>
        </div>
        {/*<div className="header__right">*/}
        {/*  {isAuthenticated ? (*/}
        {/*    <div className="header__profile">*/}
        {/*      <Button className="header__auth-button" label="Выход" onClick={logout}></Button>*/}
        {/*    </div>*/}
        {/*  ) : (*/}
        {/*    <div className="header__auth">*/}
        {/*      <Link to="/login" target="_blank">*/}
        {/*        <Button className="header__auth-button header__auth-button_login" link size="small">*/}
        {/*          <span className="text">Вход</span>*/}
        {/*          <i className="pi pi-sign-in icon"></i>*/}
        {/*        </Button>*/}
        {/*      </Link>*/}
        {/*      <Link to="/signup" target="_blank">*/}
        {/*        <Button className="header__auth-button" size="small">*/}
        {/*          <span className="text">Регистрация</span>*/}
        {/*          <i className="pi pi-user-plus icon"></i>*/}
        {/*        </Button>*/}
        {/*      </Link>*/}
        {/*    </div>*/}
        {/*  )}*/}
        {/*</div>*/}
      </div>
    </nav>
  );
}

export default Header;
